import React from 'react';

const Trc20Icon = (props) => (
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="30" height="20" rx="2" fill="#FF060A"/>
    <g clipPath="url(#clip0_6867_4642)">
      <path d="M21.3184 7.27965C20.6769 6.68733 19.7894 5.78281 19.0667 5.14131L19.0239 5.11137C18.9528 5.05423 18.8725 5.00942 18.7866 4.97879C17.0438 4.65376 8.93306 3.13767 8.77482 3.15692C8.73048 3.16313 8.6881 3.17921 8.6508 3.20396L8.61017 3.23604C8.56014 3.28685 8.52214 3.34823 8.49897 3.41566L8.48828 3.44346V3.59528V3.6188C9.40136 6.1613 13.0066 14.4902 13.7165 16.4446C13.7593 16.5772 13.8406 16.8295 13.9924 16.8423H14.0266C14.1079 16.8423 14.4543 16.3847 14.4543 16.3847C14.4543 16.3847 20.6469 8.87486 21.2735 8.07512C21.3546 7.97661 21.4262 7.87064 21.4873 7.75864C21.5029 7.67101 21.4955 7.58083 21.4659 7.49689C21.4363 7.41295 21.3855 7.33811 21.3184 7.27965ZM16.0431 8.15424L18.6861 5.96243L20.2364 7.39085L16.0431 8.15424ZM15.0167 8.01097L10.4663 4.28169L17.8286 5.63954L15.0167 8.01097ZM15.4272 8.98819L20.0845 8.23763L14.7601 14.6527L15.4272 8.98819ZM9.84827 4.65376L14.636 8.71662L13.9432 14.657L9.84827 4.65376Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_6867_4642">
        <rect width="13.6854" height="13.6854" fill="white" transform="translate(8.1582 3.15723)"/>
      </clipPath>
    </defs>
  </svg>
);

export default Trc20Icon;
